import { pickSingleItemContent } from "@eusoft/webapp-framework/content/Pickers";
import { showContentPopup } from "@eusoft/webapp-framework/helpers/Editor";
import { localTable } from "@eusoft/webapp-framework/services/LocalTable";
import { router, type NavigationMode } from "@eusoft/webapp-framework/services/Router";
import { userInteraction } from "@eusoft/webapp-framework/services/UserInteraction";
import { arrayItemsSource } from "@eusoft/webapp-ui/editors/ItemsSources";
import { formatText } from "@eusoft/webapp-ui/utils/Format";
import { paymentService, type IPrinter } from "../abstraction/IPaymentService";
import { ContextSelectorPage, type IContextSelectorArgs } from "../pages";
import { context } from "../services/Context";
import { executeAsync } from "../services/DataService";
import type { Guid } from "../entities/Commands";
import type { PagesMap } from "../entities/Pages";
import { app } from "@eusoft/webapp-framework/App";

interface PrintTemplateMap {
    "InitCard": {
        walletId: Guid,
        cardCode: string
    },
    "ChargeCart": {
        cardCode: string,
        amount: string,
        paymentMethod: string,
        time: string,
        salePointName: string
    }
}


export async function selectContextAsync(options: IContextSelectorArgs) {
    const res = await showContentPopup(ContextSelectorPage.info.factory(), options);
    if (!res)
        return;
    const curContent = app.contentHost.content;
    await curContent?.refreshAsync?.();
    return true;
}

export function navigatePage<TKey extends keyof PagesMap>(page: TKey, args?: PagesMap[TKey], mode: NavigationMode = "push") {

    return router.navigatePageAsync(page, args, mode);
}

export function navigatePageForResult<TKey extends keyof PagesMap>(page: TKey, args?: PagesMap[TKey], mode: NavigationMode = "push") {

    return router.navigatePageForResultAsync(page, args, mode);
}

export async function printAsync<TKey extends keyof PrintTemplateMap & string>(templateName: TKey, args: PrintTemplateMap[TKey]) {

    const printer = await selectPrinterAsync();
    if (!printer)
        return;
    
    const template = await executeAsync("GetReceiptTemplate", {
        templateName,
        language: localTable.language,
        saleCircuitId: context.saleCircuit?.id,
        args
    });

    if (!template)
        return;

    paymentService.print(printer.model, template.commands); 
}

export async function selectPrinterAsync() {
    const printers = paymentService.listPrinters();

    if (printers?.length == 0) {
        userInteraction.messageAsync(formatText("msg-no-printers"), "warning", 3000);
        return;
    }

    let printer: IPrinter;

    if (printers.length > 1) {

        const content = pickSingleItemContent({
            itemsSource: arrayItemsSource(printers, a => a.name),
            title: "select-printer",
        });

        printer = await showContentPopup(content, undefined, {
            closeLabel: "cancel"
        });
    }
    else
        printer = printers[0];
    
    return printer;
}

